import React from "react";

// reactstrap components
import {
    Alert,
    Button,
    Card,
    CardHeader,
    Col,
    CardBody,
    FormGroup,
    Input,
    Modal,
    Row,
} from "reactstrap";
import ProductDataService from "../../services/ProductDataService";

class ProductSplitStockModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentProduct: {},
            stockRequest: [
                { warehouse_id: -1, stock: '' }
            ],
            emptyStock: false,
        };
        this.productDataService = new ProductDataService();
    }

    handleInputChanged = (index, e) => {
        const { name, value } = e.target;
        const updatedStockRequest = [...this.state.stockRequest];
        updatedStockRequest[index][name] = Number(value);
        this.setState({ stockRequest: updatedStockRequest });
    };

    setErrormessage(errorMessage, checkoutDisabled) {
        this.setState({
            errorMessage: errorMessage,
            checkoutDisabled: checkoutDisabled,
        })
        setTimeout(() => {
            this.setState({ errorMessage: undefined });
        }, 5000);
    }

    handleResponse(data, successMessage) {
        if (data?.data?.errorMessage) {
            this.setState({ errorMessage: data.data.errorMessage })
        } else if (data?.header?.status_code !== 200 && data?.header?.status_code !== 0) {
            let errorMessages = []
            data?.data?.map((data) => {
                return errorMessages.push(data?.error_message)
            })
            this.setState({ errorMessages: errorMessages })
        } else {
            this.props.toggleModal()
            this.props.setSuccessMessage(successMessage)
            this.setState({ currentProduct: {} })
            this.props.fetchData()
        }
        setTimeout(() => {
            this.setState({ successMessage: undefined, errorMessage: undefined });
        }, 5000);
    }

    onKeyUp(e) {
        delete this.state.errorMessage;
        var charCode = (typeof e.which === "undefined") ? e.keyCode : e.which;
        if (charCode === 13) {
            this.submitSplitStock();
        }
    }

    submitSplitStock() {
        const { currentProduct, stockRequest } = this.state;

        (this.state.emptyStock ?
            this.productDataService.updateStock(currentProduct.product_id, stockRequest) :
            this.productDataService.splitStock(currentProduct.product_id, stockRequest))
            .then((data) => {
                this.handleResponse(data, "Split stock berhasil disubmit");
            })
    }

    onModalOpened() {
        this.setCurrentProduct();
        this.setState({ stockRequest: [{ warehouse_id: -1, stock: '' }] })
    }

    addStockRequestRow = () => {
        this.setState(prevState => ({
            stockRequest: [...prevState.stockRequest, { warehouse_id: -1, stock: '' }]
        }));
    };

    removeStockRequestRow = (index) => () => {
        this.setState(prevState => {
            const updatedStockRequest = [...prevState.stockRequest];
            updatedStockRequest.splice(index, 1);
            return { stockRequest: updatedStockRequest };
        });
    };

    onModalClosed() {
        this.setState({
            currentProduct: {},
            stockRequest: [],
            errorMessages: [],
        })
    }

    setCurrentProduct() {
        this.setState({ currentProduct: this.props.currentProduct })
        this.setState(prevState => {
            let currentProduct = Object.assign({}, prevState.currentProduct)
            return {
                currentProduct,
                emptyStock: currentProduct.product_stock === 0,
            };
        })
    }

    hasUniqueWarehouses() {
        const warehouseIds = this.state.stockRequest.map(item => item.warehouse_id);
        const uniqueWarehouseIds = new Set(warehouseIds);
        return warehouseIds.length === uniqueWarehouseIds.size;
    }

    validStockRequest() {
        return this.state.stockRequest.every(item =>
            item.warehouse_id != null && item.warehouse_id !== '' && item.warehouse_id != -1 &&
            item.stock != null && item.stock !== ''
        );
    }

    requestedStockMatchInitialStock() {
        if (this.state.emptyStock) {
            return true
        }
        return this.state.stockRequest.reduce((sum, item) => {
            return sum + Number(item.stock || 0);
        }, 0) == this.state.currentProduct.product_stock;
    }

    render() {
        return (
            <Modal
                className="modal-dialog-centered"
                size="lg"
                isOpen={this.props.formModal}
                toggle={this.props.toggleModal}
                onOpened={this.onModalOpened.bind(this)}
                onClosed={this.onModalClosed.bind(this)}
            >
                <div className="modal-body p-0">
                    <Card className="bg-secondary shadow border-0">
                        <CardHeader className="bg-transparent">
                            <div className="text-muted text-center mt-2 mb-3">
                                <h3 className="mb-0">Split Stock produk</h3>
                            </div>
                        </CardHeader>
                        <CardBody className="px-lg-5 py-lg-5">
                            {this.state.errorMessages && this.state.errorMessages.map((errorMessage) => (
                                <Alert color="danger">
                                    {errorMessage}
                                </Alert>
                            ))}
                            {this.state.errorMessage && (
                                <Alert color="danger">
                                    {this.state.errorMessage}
                                </Alert>
                            )}
                            <FormGroup className="mb-3">
                                <Row>
                                    <Col lg="4">
                                        <label
                                            className="form-control-label"
                                            htmlFor="input-barcode"
                                        >
                                            Bacode produk
                                        </label>
                                        <Input placeholder="Barcode produk"
                                            className="form-control-alternative"
                                            name="product_barcode"
                                            id="input-barcode"
                                            value={this.state.currentProduct?.product_barcode}
                                            disabled
                                            type="text" />
                                    </Col>
                                    <Col lg="4">
                                        <label
                                            className="form-control-label"
                                            htmlFor="input-name"
                                        >
                                            Nama produk
                                        </label>
                                        <Input placeholder="Nama produk"
                                            name="product_name"
                                            className="form-control-alternative"
                                            value={this.state.currentProduct?.product_name}
                                            disabled
                                            type="text" />
                                    </Col>
                                    <Col lg="4">
                                        <label
                                            className="form-control-label"
                                            htmlFor="input-name"
                                        >
                                            Stock produk
                                        </label>
                                        <Input placeholder="Stock produk"
                                            name="product_name"
                                            className="form-control-alternative"
                                            value={this.state.currentProduct?.product_stock}
                                            disabled
                                            type="number" />
                                    </Col>
                                </Row>
                            </FormGroup>
                            <FormGroup>
                                {this.validStockRequest() && !this.requestedStockMatchInitialStock() && (
                                    <Alert color="warning">
                                        Split stock request tidak boleh melebihi/kurang dari stock warehouse saat ini.
                                    </Alert>
                                )}
                                {!this.hasUniqueWarehouses() && (
                                    <Alert color="warning">
                                        Warehouse tujuan tidak boleh sama.
                                    </Alert>
                                )}
                                {this.state.stockRequest.map((req, index) => (
                                    <Row key={index} className="mb-3">
                                        <Col lg="6">
                                            <label className="form-control-label" htmlFor={`warehouse-${index}`}>
                                                Warehouse tujuan #{index + 1}
                                            </label>
                                            <Input
                                                id={`warehouse-${index}`}
                                                placeholder="Warehouse tujuan"
                                                name="warehouse_id"
                                                type="select"
                                                value={req.warehouse_id}
                                                onChange={e => this.handleInputChanged(index, e)}
                                            >
                                                <option value='-1' disabled>Warehouse tujuan</option>
                                                {this.props.warehouses.map(warehouse => (
                                                    <option key={warehouse.warehouse_id} value={warehouse.warehouse_id}>
                                                        {warehouse.warehouse_name}
                                                    </option>
                                                ))}
                                            </Input>
                                        </Col>
                                        <Col lg="2">
                                            <label className="form-control-label" htmlFor={`stock-${index}`}>
                                                Stock
                                            </label>
                                            <Input
                                                id={`stock-${index}`}
                                                placeholder="Stock"
                                                name="stock"
                                                type="number"
                                                value={req.stock}
                                                onChange={e => this.handleInputChanged(index, e)}
                                            />
                                        </Col>
                                        <Col lg="4">
                                            <label className="form-control-label" htmlFor={`stock-${index}`}>
                                                Aksi
                                            </label>
                                            <div className="btn-wrapper">
                                                {index !== 0 && (<Button
                                                    color="danger"
                                                    type="button"
                                                    onClick={this.removeStockRequestRow(index)}
                                                >
                                                    Hapus
                                                </Button>)}
                                                <Button
                                                    color="primary"
                                                    type="button"
                                                    onClick={this.addStockRequestRow}
                                                >
                                                    Tambah
                                                </Button>
                                            </div>
                                        </Col>
                                    </Row>
                                ))}

                            </FormGroup>
                            <FormGroup>
                                <div className="btn-wrapper text-right">
                                    <Button
                                        className="my-4"
                                        color="secondary"
                                        type="button"
                                        onClick={this.props.toggleModal}
                                    >
                                        Batal
                                    </Button>
                                    <Button
                                        className="my-4"
                                        color="primary"
                                        type="button"
                                        disabled={!this.validStockRequest() || !this.requestedStockMatchInitialStock() || !this.hasUniqueWarehouses()}
                                        onClick={() => this.submitSplitStock()}
                                    >
                                        Simpan
                                    </Button>
                                </div>
                            </FormGroup>
                        </CardBody>
                    </Card>
                </div>
            </Modal>
        )
    }
}

export default ProductSplitStockModal;
